import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import translate from '@i18n'
import { desktopCSS } from '@measures/responsive'
import { formatNumberByPublication } from './utils'
import { StadiumInfoProps } from '@widgets/StadiumInfo/types'
import useSubscribeToSportsEventCache from '@hooks/useSubscribeToSportsEventCache'
import {
  SubsectionTitle,
  InfoText,
  InfoCategoryHeader,
  SubsectionWrapper,
} from '@components/LayoutTabs/SubsectionReusableComponents'

type StadiumInfoComponentProps = Omit<StadiumInfoProps, 'kind'>

const StyledContentWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing32, spacing16 },
      colors: { strokeWeak },
    },
  }) => css`
    display: flex;
    gap: ${spacing16};
    border-bottom: 1px solid ${strokeWeak};
    padding-bottom: ${spacing16};
    justify-content: space-between;
    ${desktopCSS(css`
      gap: ${spacing32};
    `)};
  `}
`

const StyledCapacityWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing4 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing4};
  `}
`

const StyledItemWrapper = styled(StyledCapacityWrapper)`
  overflow: hidden;
`

const StadiumInfoComponent: FunctionComponent<StadiumInfoComponentProps> = ({
  title,
  typeOfSport,
  matchId,
}) => {
  const existingSportsEventData = useSubscribeToSportsEventCache({
    matchId,
    typeOfSport,
  })

  if (!existingSportsEventData?.formattedData.stadium) {
    return null
  }

  const { city, country, name, capacity } =
    existingSportsEventData.formattedData.stadium

  return (
    <SubsectionWrapper>
      <SubsectionTitle>{title}</SubsectionTitle>
      <StyledContentWrapper>
        <StyledItemWrapper>
          <InfoCategoryHeader>
            {city}, {country}
          </InfoCategoryHeader>
          <InfoText>{name}</InfoText>
        </StyledItemWrapper>
        <StyledCapacityWrapper>
          <InfoCategoryHeader>
            {translate('stadiumInfo.capacity')}
          </InfoCategoryHeader>
          <InfoText>{formatNumberByPublication(capacity)}</InfoText>
        </StyledCapacityWrapper>
      </StyledContentWrapper>
    </SubsectionWrapper>
  )
}

export default StadiumInfoComponent
